import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { prettyFloatMoney } from '../../../../../../helpers/utils';
import s from './index.module.scss';

export const ExampleTable = ({ data }) => (
  <div className={s.example_table__wrap}>
    <div className={s.example_table__inner}>
      <div className={s.example_table}>
        <div className={classnames(s.example_table__thead, 'f-16 f-400')}>
          <div className={s.example_table__thead_col}>Num</div>
          <div className={s.example_table__thead_col}>Date</div>
          <div className={s.example_table__thead_col}>Flat fee</div>
          <div className={s.example_table__thead_col}>Principal</div>
          <div className={s.example_table__thead_col}>Total</div>
        </div>

        <div className={s.example_table__tbody}>
          {data.list.map((item, idx) => (
            <div className={s.example_table__tbody_row} key={idx}>
              <div className={s.example_table__tbody_col}>
                <div className="f-16 f-400 tl">{idx + 1}.</div>
              </div>
              <div className={classnames(s.example_table__tbody_col, 'tl')}>
                <span className="f-16 f-400">{moment(item.date).format('DD.MM.YYYY')}</span>
              </div>
              <div className={classnames(s.example_table__tbody_col, 'tl')}>
                <div className="f-16 f-400 tl">{item.fee ? prettyFloatMoney(item.fee) : '—'}</div>
              </div>
              <div className={classnames(s.example_table__tbody_col, 'tl')}>
                <div className="f-16 f-400 tl">
                  {item.principal ? prettyFloatMoney(item.principal) : '—'}
                </div>
              </div>
              <div className={classnames(s.example_table__tbody_col, 'tl')}>
                <div className="f-16 f-400 tl">{prettyFloatMoney(item.total)}</div>
              </div>
            </div>
          ))}

          <div className={s.example_table__tbody_row_summary}>
            <div className={s.example_table__tbody_col}>
              <div className="f-16 f-500">Total:</div>
            </div>
            <div className="example_table__tbody_col">
              <span className="f-16 f-500" />
            </div>
            <div className={classnames(s.example_table__tbody_col, 'tl')}>
              <span className="f-16 f-500">{prettyFloatMoney(data.total_fee)}</span>
            </div>
            <div className={classnames(s.example_table__tbody_col, 'tl')}>
              <span className="f-16 f-500">{prettyFloatMoney(data.total_principal)}</span>
            </div>
            <div className={classnames(s.example_table__tbody_col, 'tl')}>
              <span className="f-16 f-500">{prettyFloatMoney(data.total)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
